import React from 'react';
import styles from './entity_decision_list_modal.module.scss';

type Props = {
  title: string;
  subtitle: string;
  onClose: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export function EntityDecisionListModalHeader({
  title,
  subtitle,
  onClose,
}: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subtitle}>{subtitle}</div>
      </div>
      <div className={styles.close} onClick={onClose}>
        <i className="material-icons icons__close" />
      </div>
    </div>
  );
}
